import UserServices from '@/services/users'

const state = () => ({
  users: {}
})

const getters = {
  users: state => Object.values(state.users),
  user: state => membership => {
    const user = state.users[membership]
    return user || null
  }
}

const mutations = {
  setUser (state, user) {
    state.users[user.membership] = user
  },
  removeUsers (state) {
    state.users = {}
  }
}

const actions = {
  async fetchUser ({ commit, getters, rootGetters }, membership) {
    let user = getters.user(membership)
    if (!user) {
      user = rootGetters['auth/allMembers'].find(user => user.num_socio === membership)
      if (user) {
        commit('setUser', {
          internalNumber: user.no,
          membership: user.num_socio,
          name: user.nombre,
          surname: user.apellidos,
          image: null
        })
      } else {
        user = await UserServices.find(membership)
        if (user) {
          commit('setUser', {
            internalNumber: user.No,
            membership: user.NumSocio,
            name: user.Name,
            surname: user.Apellidos,
            image: null
          })
        }
      }
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
